module.exports = __webpack_public_path__ + "static/media/country_ma.3e26c6cf.webp";